import SortableComponent from "./SortableComponent";

export default SortableComponent;
